import * as a from "react";
import { c as Me, a as v, u as ve } from "./index.stoqs9MZ.js";
import { u as k, b as ge, c as hn } from "./index.B4ZV02se.js";
import { P as b, d as wn } from "./index.DMLWxr4u.js";
import { c as Cn } from "./index.BW3XI7yS.js";
import { u as xn } from "./index.BhJrV2wu.js";
import { D as _n } from "./index.DNGle7LJ.js";
import { h as Rn, u as Sn, R as In, F as Pn } from "./Combination.r_wXKfB6.js";
import { u as $ } from "./index.BUG7NYeV.js";
import { c as he, R as we, a as Dn, C as En, A as bn } from "./index.C27qk3BS.js";
import { P as yn } from "./index.RcubEhGW.js";
import { P as Y } from "./index.TrmYLGk6.js";
import { c as Ce, I as Tn, R as Nn } from "./index.BwKnBOdH.js";
import { j as c } from "./jsx-runtime.DGlMoOmv.js";
function ee(e) {
  const o = a.useRef(e);
  return a.useEffect(() => {
    o.current = e;
  }), a.useMemo(() => (...n) => o.current?.(...n), []);
}
var Q = ["Enter", " "], An = ["ArrowDown", "PageUp", "Home"], xe = ["ArrowUp", "PageDown", "End"], On = [...An, ...xe], jn = {
  ltr: [...Q, "ArrowRight"],
  rtl: [...Q, "ArrowLeft"]
}, kn = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, L = "Menu", [O, Ln, Gn] = Cn(L), [S, _e] = Me(L, [
  Gn,
  he,
  Ce
]), G = he(), Re = Ce(), [Se, _] = S(L), [Fn, F] = S(L), Ie = (e) => {
  const { __scopeMenu: o, open: n = !1, children: r, dir: t, onOpenChange: s, modal: i = !0 } = e, d = G(o), [f, m] = a.useState(null), p = a.useRef(!1), u = ee(s), M = xn(t);
  return a.useEffect(() => {
    const C = () => {
      p.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", C, { capture: !0 }), () => {
      document.removeEventListener("keydown", C, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ c.jsx(we, { ...d, children: /* @__PURE__ */ c.jsx(
    Se,
    {
      scope: o,
      open: n,
      onOpenChange: u,
      content: f,
      onContentChange: m,
      children: /* @__PURE__ */ c.jsx(
        Fn,
        {
          scope: o,
          onClose: a.useCallback(() => u(!1), [u]),
          isUsingKeyboardRef: p,
          dir: M,
          modal: i,
          children: r
        }
      )
    }
  ) });
};
Ie.displayName = L;
var Kn = "MenuAnchor", ne = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...r } = e, t = G(n);
    return /* @__PURE__ */ c.jsx(Dn, { ...t, ...r, ref: o });
  }
);
ne.displayName = Kn;
var oe = "MenuPortal", [Un, Pe] = S(oe, {
  forceMount: void 0
}), De = (e) => {
  const { __scopeMenu: o, forceMount: n, children: r, container: t } = e, s = _(oe, o);
  return /* @__PURE__ */ c.jsx(Un, { scope: o, forceMount: n, children: /* @__PURE__ */ c.jsx(Y, { present: n || s.open, children: /* @__PURE__ */ c.jsx(yn, { asChild: !0, container: t, children: r }) }) });
};
De.displayName = oe;
var x = "MenuContent", [Bn, re] = S(x), Ee = a.forwardRef(
  (e, o) => {
    const n = Pe(x, e.__scopeMenu), { forceMount: r = n.forceMount, ...t } = e, s = _(x, e.__scopeMenu), i = F(x, e.__scopeMenu);
    return /* @__PURE__ */ c.jsx(O.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c.jsx(Y, { present: r || s.open, children: /* @__PURE__ */ c.jsx(O.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ c.jsx($n, { ...t, ref: o }) : /* @__PURE__ */ c.jsx(Vn, { ...t, ref: o }) }) }) });
  }
), $n = a.forwardRef(
  (e, o) => {
    const n = _(x, e.__scopeMenu), r = a.useRef(null), t = k(o, r);
    return a.useEffect(() => {
      const s = r.current;
      if (s) return Rn(s);
    }, []), /* @__PURE__ */ c.jsx(
      te,
      {
        ...e,
        ref: t,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: v(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Vn = a.forwardRef((e, o) => {
  const n = _(x, e.__scopeMenu);
  return /* @__PURE__ */ c.jsx(
    te,
    {
      ...e,
      ref: o,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Xn = hn("MenuContent.ScrollLock"), te = a.forwardRef(
  (e, o) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: t,
      onOpenAutoFocus: s,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: d,
      onEntryFocus: f,
      onEscapeKeyDown: m,
      onPointerDownOutside: p,
      onFocusOutside: u,
      onInteractOutside: M,
      onDismiss: C,
      disableOutsideScroll: g,
      ...I
    } = e, y = _(x, n), P = F(x, n), dn = G(n), ln = Re(n), ie = Ln(n), [pn, de] = a.useState(null), K = a.useRef(null), fn = k(o, K, y.onContentChange), U = a.useRef(0), B = a.useRef(""), mn = a.useRef(0), z = a.useRef(null), le = a.useRef("right"), Z = a.useRef(0), Mn = g ? In : a.Fragment, vn = g ? { as: Xn, allowPinchZoom: !0 } : void 0, gn = (l) => {
      const E = B.current + l, R = ie().filter((w) => !w.disabled), T = document.activeElement, q = R.find((w) => w.ref.current === T)?.textValue, J = R.map((w) => w.textValue), pe = ro(J, E, q), N = R.find((w) => w.textValue === pe)?.ref.current;
      (function w(fe) {
        B.current = fe, window.clearTimeout(U.current), fe !== "" && (U.current = window.setTimeout(() => w(""), 1e3));
      })(E), N && setTimeout(() => N.focus());
    };
    a.useEffect(() => () => window.clearTimeout(U.current), []), Sn();
    const D = a.useCallback((l) => le.current === z.current?.side && ao(l, z.current?.area), []);
    return /* @__PURE__ */ c.jsx(
      Bn,
      {
        scope: n,
        searchRef: B,
        onItemEnter: a.useCallback(
          (l) => {
            D(l) && l.preventDefault();
          },
          [D]
        ),
        onItemLeave: a.useCallback(
          (l) => {
            D(l) || (K.current?.focus(), de(null));
          },
          [D]
        ),
        onTriggerLeave: a.useCallback(
          (l) => {
            D(l) && l.preventDefault();
          },
          [D]
        ),
        pointerGraceTimerRef: mn,
        onPointerGraceIntentChange: a.useCallback((l) => {
          z.current = l;
        }, []),
        children: /* @__PURE__ */ c.jsx(Mn, { ...vn, children: /* @__PURE__ */ c.jsx(
          Pn,
          {
            asChild: !0,
            trapped: t,
            onMountAutoFocus: v(s, (l) => {
              l.preventDefault(), K.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ c.jsx(
              _n,
              {
                asChild: !0,
                disableOutsidePointerEvents: d,
                onEscapeKeyDown: m,
                onPointerDownOutside: p,
                onFocusOutside: u,
                onInteractOutside: M,
                onDismiss: C,
                children: /* @__PURE__ */ c.jsx(
                  Nn,
                  {
                    asChild: !0,
                    ...ln,
                    dir: P.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: pn,
                    onCurrentTabStopIdChange: de,
                    onEntryFocus: v(f, (l) => {
                      P.isUsingKeyboardRef.current || l.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ c.jsx(
                      En,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Xe(y.open),
                        "data-radix-menu-content": "",
                        dir: P.dir,
                        ...dn,
                        ...I,
                        ref: fn,
                        style: { outline: "none", ...I.style },
                        onKeyDown: v(I.onKeyDown, (l) => {
                          const R = l.target.closest("[data-radix-menu-content]") === l.currentTarget, T = l.ctrlKey || l.altKey || l.metaKey, q = l.key.length === 1;
                          R && (l.key === "Tab" && l.preventDefault(), !T && q && gn(l.key));
                          const J = K.current;
                          if (l.target !== J || !On.includes(l.key)) return;
                          l.preventDefault();
                          const N = ie().filter((w) => !w.disabled).map((w) => w.ref.current);
                          xe.includes(l.key) && N.reverse(), no(N);
                        }),
                        onBlur: v(e.onBlur, (l) => {
                          l.currentTarget.contains(l.target) || (window.clearTimeout(U.current), B.current = "");
                        }),
                        onPointerMove: v(
                          e.onPointerMove,
                          j((l) => {
                            const E = l.target, R = Z.current !== l.clientX;
                            if (l.currentTarget.contains(E) && R) {
                              const T = l.clientX > Z.current ? "right" : "left";
                              le.current = T, Z.current = l.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ee.displayName = x;
var Yn = "MenuGroup", ae = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c.jsx(b.div, { role: "group", ...r, ref: o });
  }
);
ae.displayName = Yn;
var Hn = "MenuLabel", be = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c.jsx(b.div, { ...r, ref: o });
  }
);
be.displayName = Hn;
var V = "MenuItem", me = "menu.itemSelect", H = a.forwardRef(
  (e, o) => {
    const { disabled: n = !1, onSelect: r, ...t } = e, s = a.useRef(null), i = F(V, e.__scopeMenu), d = re(V, e.__scopeMenu), f = k(o, s), m = a.useRef(!1), p = () => {
      const u = s.current;
      if (!n && u) {
        const M = new CustomEvent(me, { bubbles: !0, cancelable: !0 });
        u.addEventListener(me, (C) => r?.(C), { once: !0 }), wn(u, M), M.defaultPrevented ? m.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ c.jsx(
      ye,
      {
        ...t,
        ref: f,
        disabled: n,
        onClick: v(e.onClick, p),
        onPointerDown: (u) => {
          e.onPointerDown?.(u), m.current = !0;
        },
        onPointerUp: v(e.onPointerUp, (u) => {
          m.current || u.currentTarget?.click();
        }),
        onKeyDown: v(e.onKeyDown, (u) => {
          const M = d.searchRef.current !== "";
          n || M && u.key === " " || Q.includes(u.key) && (u.currentTarget.click(), u.preventDefault());
        })
      }
    );
  }
);
H.displayName = V;
var ye = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: t, ...s } = e, i = re(V, n), d = Re(n), f = a.useRef(null), m = k(o, f), [p, u] = a.useState(!1), [M, C] = a.useState("");
    return a.useEffect(() => {
      const g = f.current;
      g && C((g.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ c.jsx(
      O.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: t ?? M,
        children: /* @__PURE__ */ c.jsx(Tn, { asChild: !0, ...d, focusable: !r, children: /* @__PURE__ */ c.jsx(
          b.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...s,
            ref: m,
            onPointerMove: v(
              e.onPointerMove,
              j((g) => {
                r ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: v(
              e.onPointerLeave,
              j((g) => i.onItemLeave(g))
            ),
            onFocus: v(e.onFocus, () => u(!0)),
            onBlur: v(e.onBlur, () => u(!1))
          }
        ) })
      }
    );
  }
), Wn = "MenuCheckboxItem", Te = a.forwardRef(
  (e, o) => {
    const { checked: n = !1, onCheckedChange: r, ...t } = e;
    return /* @__PURE__ */ c.jsx(ke, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ c.jsx(
      H,
      {
        role: "menuitemcheckbox",
        "aria-checked": X(n) ? "mixed" : n,
        ...t,
        ref: o,
        "data-state": ue(n),
        onSelect: v(
          t.onSelect,
          () => r?.(X(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Te.displayName = Wn;
var Ne = "MenuRadioGroup", [zn, Zn] = S(
  Ne,
  { value: void 0, onValueChange: () => {
  } }
), Ae = a.forwardRef(
  (e, o) => {
    const { value: n, onValueChange: r, ...t } = e, s = ee(r);
    return /* @__PURE__ */ c.jsx(zn, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ c.jsx(ae, { ...t, ref: o }) });
  }
);
Ae.displayName = Ne;
var Oe = "MenuRadioItem", je = a.forwardRef(
  (e, o) => {
    const { value: n, ...r } = e, t = Zn(Oe, e.__scopeMenu), s = n === t.value;
    return /* @__PURE__ */ c.jsx(ke, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ c.jsx(
      H,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...r,
        ref: o,
        "data-state": ue(s),
        onSelect: v(
          r.onSelect,
          () => t.onValueChange?.(n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
je.displayName = Oe;
var se = "MenuItemIndicator", [ke, qn] = S(
  se,
  { checked: !1 }
), Le = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, forceMount: r, ...t } = e, s = qn(se, n);
    return /* @__PURE__ */ c.jsx(
      Y,
      {
        present: r || X(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ c.jsx(
          b.span,
          {
            ...t,
            ref: o,
            "data-state": ue(s.checked)
          }
        )
      }
    );
  }
);
Le.displayName = se;
var Jn = "MenuSeparator", Ge = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ c.jsx(
      b.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: o
      }
    );
  }
);
Ge.displayName = Jn;
var Qn = "MenuArrow", Fe = a.forwardRef(
  (e, o) => {
    const { __scopeMenu: n, ...r } = e, t = G(n);
    return /* @__PURE__ */ c.jsx(bn, { ...t, ...r, ref: o });
  }
);
Fe.displayName = Qn;
var ce = "MenuSub", [eo, Ke] = S(ce), Ue = (e) => {
  const { __scopeMenu: o, children: n, open: r = !1, onOpenChange: t } = e, s = _(ce, o), i = G(o), [d, f] = a.useState(null), [m, p] = a.useState(null), u = ee(t);
  return a.useEffect(() => (s.open === !1 && u(!1), () => u(!1)), [s.open, u]), /* @__PURE__ */ c.jsx(we, { ...i, children: /* @__PURE__ */ c.jsx(
    Se,
    {
      scope: o,
      open: r,
      onOpenChange: u,
      content: m,
      onContentChange: p,
      children: /* @__PURE__ */ c.jsx(
        eo,
        {
          scope: o,
          contentId: $(),
          triggerId: $(),
          trigger: d,
          onTriggerChange: f,
          children: n
        }
      )
    }
  ) });
};
Ue.displayName = ce;
var A = "MenuSubTrigger", Be = a.forwardRef(
  (e, o) => {
    const n = _(A, e.__scopeMenu), r = F(A, e.__scopeMenu), t = Ke(A, e.__scopeMenu), s = re(A, e.__scopeMenu), i = a.useRef(null), { pointerGraceTimerRef: d, onPointerGraceIntentChange: f } = s, m = { __scopeMenu: e.__scopeMenu }, p = a.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return a.useEffect(() => p, [p]), a.useEffect(() => {
      const u = d.current;
      return () => {
        window.clearTimeout(u), f(null);
      };
    }, [d, f]), /* @__PURE__ */ c.jsx(ne, { asChild: !0, ...m, children: /* @__PURE__ */ c.jsx(
      ye,
      {
        id: t.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": t.contentId,
        "data-state": Xe(n.open),
        ...e,
        ref: ge(o, t.onTriggerChange),
        onClick: (u) => {
          e.onClick?.(u), !(e.disabled || u.defaultPrevented) && (u.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: v(
          e.onPointerMove,
          j((u) => {
            s.onItemEnter(u), !u.defaultPrevented && !e.disabled && !n.open && !i.current && (s.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: v(
          e.onPointerLeave,
          j((u) => {
            p();
            const M = n.content?.getBoundingClientRect();
            if (M) {
              const C = n.content?.dataset.side, g = C === "right", I = g ? -5 : 5, y = M[g ? "left" : "right"], P = M[g ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: u.clientX + I, y: u.clientY },
                  { x: y, y: M.top },
                  { x: P, y: M.top },
                  { x: P, y: M.bottom },
                  { x: y, y: M.bottom }
                ],
                side: C
              }), window.clearTimeout(d.current), d.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(u), u.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: v(e.onKeyDown, (u) => {
          const M = s.searchRef.current !== "";
          e.disabled || M && u.key === " " || jn[r.dir].includes(u.key) && (n.onOpenChange(!0), n.content?.focus(), u.preventDefault());
        })
      }
    ) });
  }
);
Be.displayName = A;
var $e = "MenuSubContent", Ve = a.forwardRef(
  (e, o) => {
    const n = Pe(x, e.__scopeMenu), { forceMount: r = n.forceMount, ...t } = e, s = _(x, e.__scopeMenu), i = F(x, e.__scopeMenu), d = Ke($e, e.__scopeMenu), f = a.useRef(null), m = k(o, f);
    return /* @__PURE__ */ c.jsx(O.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ c.jsx(Y, { present: r || s.open, children: /* @__PURE__ */ c.jsx(O.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ c.jsx(
      te,
      {
        id: d.contentId,
        "aria-labelledby": d.triggerId,
        ...t,
        ref: m,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          i.isUsingKeyboardRef.current && f.current?.focus(), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: v(e.onFocusOutside, (p) => {
          p.target !== d.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: v(e.onEscapeKeyDown, (p) => {
          i.onClose(), p.preventDefault();
        }),
        onKeyDown: v(e.onKeyDown, (p) => {
          const u = p.currentTarget.contains(p.target), M = kn[i.dir].includes(p.key);
          u && M && (s.onOpenChange(!1), d.trigger?.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
Ve.displayName = $e;
function Xe(e) {
  return e ? "open" : "closed";
}
function X(e) {
  return e === "indeterminate";
}
function ue(e) {
  return X(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function no(e) {
  const o = document.activeElement;
  for (const n of e)
    if (n === o || (n.focus(), document.activeElement !== o)) return;
}
function oo(e, o) {
  return e.map((n, r) => e[(o + r) % e.length]);
}
function ro(e, o, n) {
  const t = o.length > 1 && Array.from(o).every((m) => m === o[0]) ? o[0] : o, s = n ? e.indexOf(n) : -1;
  let i = oo(e, Math.max(s, 0));
  t.length === 1 && (i = i.filter((m) => m !== n));
  const f = i.find(
    (m) => m.toLowerCase().startsWith(t.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function to(e, o) {
  const { x: n, y: r } = e;
  let t = !1;
  for (let s = 0, i = o.length - 1; s < o.length; i = s++) {
    const d = o[s], f = o[i], m = d.x, p = d.y, u = f.x, M = f.y;
    p > r != M > r && n < (u - m) * (r - p) / (M - p) + m && (t = !t);
  }
  return t;
}
function ao(e, o) {
  if (!o) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return to(n, o);
}
function j(e) {
  return (o) => o.pointerType === "mouse" ? e(o) : void 0;
}
var so = Ie, co = ne, uo = De, io = Ee, lo = ae, po = be, fo = H, mo = Te, Mo = Ae, vo = je, go = Le, ho = Ge, wo = Fe, Co = Ue, xo = Be, _o = Ve, W = "DropdownMenu", [Ro, Jo] = Me(
  W,
  [_e]
), h = _e(), [So, Ye] = Ro(W), He = (e) => {
  const {
    __scopeDropdownMenu: o,
    children: n,
    dir: r,
    open: t,
    defaultOpen: s,
    onOpenChange: i,
    modal: d = !0
  } = e, f = h(o), m = a.useRef(null), [p, u] = ve({
    prop: t,
    defaultProp: s ?? !1,
    onChange: i,
    caller: W
  });
  return /* @__PURE__ */ c.jsx(
    So,
    {
      scope: o,
      triggerId: $(),
      triggerRef: m,
      contentId: $(),
      open: p,
      onOpenChange: u,
      onOpenToggle: a.useCallback(() => u((M) => !M), [u]),
      modal: d,
      children: /* @__PURE__ */ c.jsx(so, { ...f, open: p, onOpenChange: u, dir: r, modal: d, children: n })
    }
  );
};
He.displayName = W;
var We = "DropdownMenuTrigger", ze = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...t } = e, s = Ye(We, n), i = h(n);
    return /* @__PURE__ */ c.jsx(co, { asChild: !0, ...i, children: /* @__PURE__ */ c.jsx(
      b.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...t,
        ref: ge(o, s.triggerRef),
        onPointerDown: v(e.onPointerDown, (d) => {
          !r && d.button === 0 && d.ctrlKey === !1 && (s.onOpenToggle(), s.open || d.preventDefault());
        }),
        onKeyDown: v(e.onKeyDown, (d) => {
          r || (["Enter", " "].includes(d.key) && s.onOpenToggle(), d.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(d.key) && d.preventDefault());
        })
      }
    ) });
  }
);
ze.displayName = We;
var Io = "DropdownMenuPortal", Ze = (e) => {
  const { __scopeDropdownMenu: o, ...n } = e, r = h(o);
  return /* @__PURE__ */ c.jsx(uo, { ...r, ...n });
};
Ze.displayName = Io;
var qe = "DropdownMenuContent", Je = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...r } = e, t = Ye(qe, n), s = h(n), i = a.useRef(!1);
    return /* @__PURE__ */ c.jsx(
      io,
      {
        id: t.contentId,
        "aria-labelledby": t.triggerId,
        ...s,
        ...r,
        ref: o,
        onCloseAutoFocus: v(e.onCloseAutoFocus, (d) => {
          i.current || t.triggerRef.current?.focus(), i.current = !1, d.preventDefault();
        }),
        onInteractOutside: v(e.onInteractOutside, (d) => {
          const f = d.detail.originalEvent, m = f.button === 0 && f.ctrlKey === !0, p = f.button === 2 || m;
          (!t.modal || p) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Je.displayName = qe;
var Po = "DropdownMenuGroup", Qe = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
    return /* @__PURE__ */ c.jsx(lo, { ...t, ...r, ref: o });
  }
);
Qe.displayName = Po;
var Do = "DropdownMenuLabel", en = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
    return /* @__PURE__ */ c.jsx(po, { ...t, ...r, ref: o });
  }
);
en.displayName = Do;
var Eo = "DropdownMenuItem", nn = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
    return /* @__PURE__ */ c.jsx(fo, { ...t, ...r, ref: o });
  }
);
nn.displayName = Eo;
var bo = "DropdownMenuCheckboxItem", on = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(mo, { ...t, ...r, ref: o });
});
on.displayName = bo;
var yo = "DropdownMenuRadioGroup", rn = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(Mo, { ...t, ...r, ref: o });
});
rn.displayName = yo;
var To = "DropdownMenuRadioItem", tn = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(vo, { ...t, ...r, ref: o });
});
tn.displayName = To;
var No = "DropdownMenuItemIndicator", an = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(go, { ...t, ...r, ref: o });
});
an.displayName = No;
var Ao = "DropdownMenuSeparator", sn = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(ho, { ...t, ...r, ref: o });
});
sn.displayName = Ao;
var Oo = "DropdownMenuArrow", jo = a.forwardRef(
  (e, o) => {
    const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
    return /* @__PURE__ */ c.jsx(wo, { ...t, ...r, ref: o });
  }
);
jo.displayName = Oo;
var ko = (e) => {
  const { __scopeDropdownMenu: o, children: n, open: r, onOpenChange: t, defaultOpen: s } = e, i = h(o), [d, f] = ve({
    prop: r,
    defaultProp: s ?? !1,
    onChange: t,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ c.jsx(Co, { ...i, open: d, onOpenChange: f, children: n });
}, Lo = "DropdownMenuSubTrigger", cn = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(xo, { ...t, ...r, ref: o });
});
cn.displayName = Lo;
var Go = "DropdownMenuSubContent", un = a.forwardRef((e, o) => {
  const { __scopeDropdownMenu: n, ...r } = e, t = h(n);
  return /* @__PURE__ */ c.jsx(
    _o,
    {
      ...t,
      ...r,
      ref: o,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
un.displayName = Go;
var Qo = He, er = ze, nr = Ze, or = Je, rr = Qe, tr = en, ar = nn, sr = on, cr = rn, ur = tn, ir = an, dr = sn, lr = ko, pr = cn, fr = un;
export {
  or as C,
  rr as G,
  ar as I,
  tr as L,
  nr as P,
  Qo as R,
  lr as S,
  er as T,
  cr as a,
  sr as b,
  ir as c,
  ur as d,
  dr as e,
  fr as f,
  pr as g
};
//# sourceMappingURL=index.DK0Z0VgS.js.map
